import React, { useEffect, useState } from 'react';
import { FieldProps, FieldValidation } from '@rjsf/core';
import Select from 'react-select';
import { useGetAPI } from '../../Utils/useGetAPI';
import { Progress } from '@backstage/core-components';
import Alert from '@material-ui/lab/Alert';
import axios from 'axios';
import { useAsync } from 'react-use';
import { FormControl, FormLabel } from '@material-ui/core';
import { useApi, microsoftAuthApiRef } from '@backstage/core-plugin-api';

type squadFieldType = {
  squad: string;
};

export const SquadDropdown = ({ onChange }: FieldProps<any>) => {
  const [formState, setFormState] = useState<squadFieldType>({
    squad: '',
  });

  const setFieldState = (key: string, value: string) => {
    const newState = {
      ...formState,
      [key]: value,
    };

    setFormState(newState);
  };

  onChange(formState);

  type SquadObj = {
    Squad: {
      Name: string;
      BusinessUnit: string;
      Mission: string;
      TechLeads: string[];
      ProductManagers: string[];
      GroupIds: string[];
    };
  };

  const url = useGetAPI();
  const identityAPI = useApi(microsoftAuthApiRef);

  const { value, loading, error } = useAsync(async (): Promise<SquadObj[]> => {
    const token = await identityAPI.getIdToken();
    const response = await axios.get<SquadObj[]>(
      `${url}/v1/api/devops/squadRegistries`,
      {
        headers: {
          Authorization: `Basic ${token}`,
        },
      },
    );
    const data = await response.data;

    return data;
  }, []);

  if (loading) {
    return <Progress />;
  } else if (error) {
    return <Alert severity="error">{error.message}</Alert>;
  }

  const options = value.Squads.map((squad: { Name: String }) => {
    return {
      value: squad.Name !== null ? squad.Name : 'N/A',
      label: squad.Name !== null ? squad.Name : 'N/A',
    };
  });

  const sortedArr = options.sort((a, b) => a.value.localeCompare(b.value));

  function changeHandler(str: string) {
    if (str.includes('squad')) {
      setFieldState('squad', str);
    } else {
      setFieldState('squad', `${str}-squad`);
    }
  }

  const customStyles = {
    singleValue: (provided: any) => ({
      ...provided,
      height: '100%',
      color: 'black',
      paddingTop: '3px',
    }),
    menuList: (provided: any) => ({
      ...provided,
      color: 'black',
    }),
  };

  return (
    <FormControl>
      <FormLabel
        style={{
          color: '#fff',
          fontSize: '0.875rem',
          transform: 'initial',
          fontFamily: 'Roboto',
          fontWeight: 'bold',
        }}
      >
        Squad
      </FormLabel>
      <div
        style={{
          width: '300px',
          marginTop: '10px',
        }}
      >
        <Select
          styles={customStyles}
          options={sortedArr}
          isSearchable
          onChange={e => {
            changeHandler(e?.value);
          }}
          menuPortalTarget={document.body}
          menuPosition="absolute"
          menuShouldScrollIntoView={false}
        />
      </div>
    </FormControl>
  );
};

export const squadValidation = (
  value: squadFieldType,
  validation: FieldValidation,
) => {
  if (value.squad === undefined) {
    validation.addError('Please select from the dropwdown');
  }

  if (value.squad !== undefined && value.squad.length <= 1) {
    validation.addError('Please select from the dropwdown');
  }
};
